import HttprepoTAAL from "../../../repos/HttpRepoTaal";

export default class TipologiaAreaHttpRepo extends HttprepoTAAL {
  getTable() {
    return "TipologiaArea";
  }
}
